export enum MaintenanceTypes {
  Maintenance = "MAINTENANCE",
  Full = "FULL_IMPACT",
  Partial = "PARTIAL_IMPACT",
  Feature = "FEATURE_SPECIFIC",
}
